import { AxiosInstance, AxiosRequestConfig } from 'axios';

import {
  IOrderFilterParam,
  IOrderPaginatedListData,
  IOrderService
} from './order.types';
import { IOrderData } from '@/models/order';

/** OrderService class order API calls */
export class OrderService implements IOrderService {
  private endpoint: string;

  /** OrderService constructor */
  constructor(private axios: AxiosInstance) {
    this.endpoint = 'v1/orders/';
  }

  /** Method to fetch a paginated list of orders from the API */
  fetchOrders(filter?: IOrderFilterParam): Promise<IOrderPaginatedListData> {
    const config: AxiosRequestConfig = { timeout: 10 * (60 * 1000) };
    if (filter) {
      config.params = filter;
    }

    return this.axios.get(`${this.endpoint}`, config).then(({ data }) => data);
  }

  /** Method to fetch a single order by their ID from the API */
  fetchOrder(series: string): Promise<IOrderData> {
    return this.axios
      .get(`${this.endpoint}${series}/`, {
        timeout: 10 * (60 * 1000)
      })
      .then(({ data }) => data);
  }

  /** Method to create a new order on the API */
  createOrder(data: IOrderData): Promise<IOrderData> {
    return this.axios.post(`${this.endpoint}`, data).then(({ data }) => data);
  }

  /** Method to update an existing order on the API */
  updateOrder(data: IOrderData): Promise<IOrderData> {
    return this.axios
      .patch(`${this.endpoint}${data.series}/`, data)
      .then(({ data }) => data);
  }

  /** Method to delete a order by their ID from the API */
  deleteOrder(series: string): Promise<void> {
    return this.axios
      .delete(`${this.endpoint}${series}/`)
      .then(({ data }) => data);
  }

  exportOrderPriceDistribution(series: string): Promise<Blob> {
    return this.axios
      .get<Blob>(`${this.endpoint}export/`, {
        params: {
          order: series
        },
        responseType: 'blob'
      })
      .then(({ data }) => data);
  }
}
